<button
  class="btn btn-qundis-primary me-3"
  [matMenuTriggerFor]="availableSolutionsMenu">
  <i class="bi bi bi-chevron-down me-2"></i>
  <span>Lösung zuweisen</span>
  <mat-menu #availableSolutionsMenu="matMenu" class="solutions-menu">
    <!-- Menu Heading -->
    <div class="menu-header" mat-menu-item disabled>
      <strong>Verfügbare Lösungen</strong>
    </div>
    <mat-divider></mat-divider>

    <!-- Solution Items -->
    @for (solution of availableSolutions(); track solution.id) {
      <button
        mat-menu-item
        class="solution-menu-item"
        (click)="solutionSelected.emit(solution)"
      >
        <span>{{ solution.name }}</span>
      </button>
    }
    <!-- No solutions fallback -->
    <div *ngIf="availableSolutions()?.length === 0" mat-menu-item disabled>
      <em class="text-muted">Keine Lösungen verfügbar</em>
    </div>
  </mat-menu>
</button>
